import { CSSTransition } from "react-transition-group";
import React, { useState, useEffect, useRef } from "react";
import { BiCog } from "react-icons/bi";
import { BiArrowBack } from "react-icons/bi";
import { BiArchive } from "react-icons/bi";
import { BiRightArrowAlt } from "react-icons/bi";

function DropdownMenu() {
  const [activeMenu, setActiveMenu] = useState("main");
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
  }, []);

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(props) {
    return (
      <a
        href="#"
        className="menu-item"
        onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}
      >
        <span className="icon-button toggle">{props.leftIcon}</span>
        {props.children}
        <span className="icon-right">{props.rightIcon}</span>
      </a>
    );
  }

  return (
    <div className="dropdown" style={{ height: menuHeight }} ref={dropdownRef}>
      <CSSTransition
        in={activeMenu === "main"}
        timeout={500}
        classNames="menu-primary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="despre-anaf"
          >
            Despre ANAF
          </DropdownItem>
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="asistenta"
          >
            Asistență Contribuabili
          </DropdownItem>
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="servicii"
          >
            Servicii online
          </DropdownItem>
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="info-publice"
          >
            Info publice
          </DropdownItem>
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="info-anaf"
          >
            Info ANAF
          </DropdownItem>
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="info-ue"
          >
            Info UE
          </DropdownItem>
          <DropdownItem
            leftIcon={<BiArchive />}
            rightIcon={<BiRightArrowAlt />}
            goToMenu="contact"
          >
            Contact
          </DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "despre-anaf"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Conducere ANAF</DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Organizare</DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Strategii ANAF</DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "asistenta"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Informații privind obligațiile fiscale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Declararea obligaţiilor fiscale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Plata obligaţiilor fiscale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Programe utile</DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Legislaţie</DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Acorduri internaționale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Servicii oferite contribuabililor
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Carta contribuabilului
          </DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "servicii"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Inregistrare utilizatori
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Descărcare declaraţii electronice
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Programări online
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Registre</DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Rapoarte tranzacții și transferuri
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Servicii WEB - ANAF
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Obligaţii restante către bugete
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Rambursare TVA din UE
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Notificări</DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "info-publice"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Informaţii de interes public
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Codul de conduită al personalului ANAF
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Formular de contact
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Strategia Națională Anticorupție
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Trasabilitate produse din TUTUN
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Situaţia deconturilor de TVA
          </DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "info-anaf"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Consultare publică
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Protecția datelor cu caracter personal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Relaţii internaţionale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Granturi Norvegiene 2009 - 2014
          </DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "info-ue"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Sancţiuni internaţionale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>Info Brexit</DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Rambursări TVA din UE
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            VIES solicitare verificare cod TVA
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            VIES verificarea codului TVA
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>EMCS</DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === "contact"}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<BiArrowBack />}>
            Inapoi la meniul principal
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Formular de contact
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Relaţii Publice şi Mass-Media
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Contact unități fiscale
          </DropdownItem>
          <DropdownItem leftIcon={<BiArchive />}>
            Afişare sediu unitate fiscală
          </DropdownItem>
        </div>
      </CSSTransition>
    </div>
  );
}

export default DropdownMenu;
